"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.build_data = void 0;
exports.build_data = { "build_version": "3.3.14.10", "build_date": "2025-11-19T15:39:41.108Z", "build_branch": "development", "build_commit": "65ce9afd2b82a5ae2caa654d05c9fd88c1e7790a" };
//# sourceMappingURL=build_data.js.map